import {
  RESET_OFFER_STORE,
  SET_CALLBACK_AUTH,
  SET_GLOBAL_ALERT,
  SET_OAUTH_SETTINGS,
  SET_OFFER,
  SET_OFFER_STORE,
  SET_USER_SIGNED_UP,
  SHOW_SPLASH_SCREEN,
  UPDATE_OFFER,
} from '../actions/offer.actions';

/**
 * @typedef {Object} Offer
 * @property {number} id
 * @property {string} name
 * @property {number} user_id
 * @property {string} pic
 * @property {string} status
 * @property {number} goal
 * @property {any} estimated_payments
 * @property {bool} inst_user_post_stats_required
 * @property {string} description
 * @property {number} content_approval_drafts_count
 * @property {string} content_approval_influencer_instructions
 * @property {string} event_address
 * @property {string} event_title
 * @property {string} event_description
 * @property {string} influencer_content_approval_due_date
 * @property {string} other_deliverable_instructions
 * @property {import('../shared/components/ObjectAttribute/ObjectAttribute').ObjectAttributeMetadata[]} object_attribute_metadata
 * @property {import('../clients/pages/Campaign/components/ContentApprovalCard').UserOffer} user_offer
 * @property {import('../influencer/pages/offer/ApplySidePane/SelectReward').Reward[]} rewards
 *
 *
 * @typedef {Object} SplashSettings
 * @property {boolean} show
 * @property {string?} text
 * @property {number=3000} timeout
 *
 *
 * @typedef {Object} AlertSettings
 * @property {any} content
 * @property {string='success'} variant
 *
 *
 * @typedef {Object} OfferStore
 * @property {Offer} offer
 * @property {boolean} userSignedUp
 * @property {number} updateOffer
 * @property {SplashSettings} splashSettings
 * @property {AlertSettings} alertSettings
 * @property {any} callbackAuth
 * @property {string} offerId
 * @property {string} path
 */
const initialState = {
  offer: null,
  offerId: null,
  path: '/offer',
  userSignedUp: false,
  updateOffer: null,
  splashSettings: null,
  alertSettings: null,
  callbackAuth: null,
  oAuthSettings: {
    facebook: {
      process: false,
      completed: false,
      response: null,
      required: false,
      optional: false,
      connected: false,
    },
    youtube: {
      process: false,
      required: false,
      completed: false,
      response: null,
      connected: false,
    }
  }
};

export default function offerReducer(state = initialState, action) {
  switch (action.type) {
    case SET_OFFER:
      return {
        ...state,
        offer: action.payload,
      };
    case SET_USER_SIGNED_UP:
      return {
        ...state,
        userSignedUp: action.payload
      };
    case SHOW_SPLASH_SCREEN:
      return {
        ...state,
        splashSettings: action.payload
      };
    case SET_CALLBACK_AUTH:
      return {
        ...state,
        callbackAuth: action.payload
      };
    case SET_GLOBAL_ALERT:
      return {
        ...state,
        alertSettings: action.payload
      };
    case SET_OFFER_STORE:
      return {
        ...state,
        ...action.payload
      };
    case UPDATE_OFFER:
      return {
        ...state,
        updateOffer: action.payload
      };
    case SET_OAUTH_SETTINGS:
      return {
        ...state,
        oAuthSettings: {
          ...state.oAuthSettings,
          ...action.payload
        }
      };
    case RESET_OFFER_STORE:
      return { ...initialState };
    default:
      return state;
  }
}